"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var TabsContext_1 = require("./TabsContext");
var StyledUnderline = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  transition: all 0.2s ease;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  transition: all 0.2s ease;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n  "], ["\n    background-color: ", ";\n  "])), theme.colors.primary);
}, function (_a) {
    var _b = _a.position, left = _b.left, width = _b.width, top = _b.top, height = _b.height;
    return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    left: ", "px;\n    width: ", "px;\n    top: ", "px;\n    height: ", "px;\n  "], ["\n    left: ", "px;\n    width: ", "px;\n    top: ", "px;\n    height: ", "px;\n  "])), left, width, top, height);
});
var TabUnderline = react_1.forwardRef(function TabUnderline(_a, ref) {
    var as = _a.as, _b = _a.basis, basis = _b === void 0 ? 2 : _b, _c = _a["aria-hidden"], ariaHidden = _c === void 0 ? true : _c, props = __rest(_a, ["as", "basis", 'aria-hidden']);
    var _d = TabsContext_1.useTabsContext(), activeIndex = _d.activeIndex, orientation = _d.orientation;
    var _e = TabsContext_1.useTabListContext(), tabsRef = _e.tabsRef, tabListRef = _e.tabListRef;
    var _f = __read(react_1.useState(null), 2), position = _f[0], setPosition = _f[1];
    react_1.useEffect(function () {
        var el = tabsRef.current && tabsRef.current[activeIndex];
        if (tabListRef.current && el) {
            var container = tabListRef.current.getBoundingClientRect();
            var _a = el.getBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom, height = _a.height, left = _a.left, right = _a.right, width = _a.width;
            switch (orientation) {
                case TabsContext_1.TabsOrientations.Horizontal: {
                    setPosition({
                        top: top_1 - container.top + (bottom - top_1) - basis,
                        height: basis,
                        left: left - container.left,
                        width: width,
                    });
                    break;
                }
                case TabsContext_1.TabsOrientations.Vertical: {
                    setPosition({
                        left: left - container.left + (right - left) - basis,
                        height: height,
                        top: top_1 - container.top,
                        width: basis,
                    });
                    break;
                }
                default:
            }
        }
    }, [activeIndex, tabsRef, tabListRef, orientation, basis]);
    return (position && react_1.default.createElement(StyledUnderline, __assign({ as: as, ref: ref, "aria-hidden": ariaHidden, position: position }, props)));
});
exports.default = react_1.memo(TabUnderline);
var templateObject_1, templateObject_2, templateObject_3;
